async function fetchVariantImages() {
  document.querySelectorAll("[data-handle]").forEach(async function (dataProductHandle) {
    await fetch("/products/" + dataProductHandle.dataset.handle + ".json").then(function (response) {
      return response.json();
    }).then(function (result) {
      dataProductHandle.querySelector(".hidevarimg").src = result.product.images[0].src;
    })
  });
}

async function reloadSwatches() {
  await fetchVariantImages().then(function () {
    function _formatMoney(cents, format) {
      if (typeof cents === 'string') {
          cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number === null) {
              return 0;
          }

          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              '$1' + thousands
          );
          const centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
          case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
          case 'amount_with_apostrophe_separator':
              value = formatWithDelimiters(cents, 2, "'");
              break;
      }

      return formatString.replace(placeholderRegex, value);

  }

    
    document.querySelectorAll(".product-item:not(.product-item-slider)").forEach(function (productItem) {
      var list = productItem.querySelector(".product-color-swatches__wrapper ul");
      if (list && list.querySelectorAll(".expand-swatches")) {
        list.querySelectorAll(".expand-swatches").forEach(function (expandSwatch) {
          expandSwatch.parentNode.removeAttribute("style")
          expandSwatch.remove();
        })
      }

      const mainPdpColorSwatches = document.querySelector(".product-color-swatches:not(.product-color-swatches--main-pdp)");
      const mainPdpColorSwatchesWidth = mainPdpColorSwatches && mainPdpColorSwatches.clientWidth || 288;

      var totalProductLimit = Math.ceil(((mainPdpColorSwatchesWidth - 28) / 28)) - 4,
          totalProducts = productItem.querySelectorAll("li[data-handle]").length,
          productImageParent = productItem.querySelector('.swatch-hover-image'),
          productImage = productItem.querySelector('.swatch-hover-image img');

      let isCust = false
      if(productItem.closest(".section__featured-collection") && productItem.closest(".section__featured-collection").classList.contains("cust-featured-collection")){
        isCust = true
      }
      list.querySelectorAll(`li:nth-child(${totalProductLimit}n+1)`).forEach(li => {
        li.classList.add("right-tooltip")
      })
      if (totalProductLimit < totalProducts) {
        if(isCust){
          if(list.querySelector(".cust-expand-swatches")){
            list.querySelector(".cust-expand-swatches").innerHTML = "<span>"+"+"+(totalProducts - totalProductLimit) + "</span><span class='tooltip'>More Colours</span>"
          }else{
            const newNode = document.createElement("li");
            newNode.innerHTML = "<span>"+"+"+(totalProducts - totalProductLimit) + "</span><span class='tooltip'>More Colours</span>"
            newNode.classList.add("cust-expand-swatches")
            list.insertBefore(newNode, list.children[totalProductLimit]);
          }
        }else{
          const newNode = document.createElement("li");
          const textNode = document.createTextNode((totalProducts - totalProductLimit) + "+");
          newNode.appendChild(textNode);
          newNode.classList.add("expand-swatches")
          list.insertBefore(newNode, list.children[totalProductLimit]);
        }
      }
      if (productItem.querySelector(".expand-swatches")) {
        var expandSwatch = productItem.querySelector(".expand-swatches");

        // Exapnd swatches (Do not delete this code, it can be used in the future)
        // productItem.querySelector(".expand-swatches").addEventListener("click", function () {
        //   expandSwatch.parentNode.style.overflow = "unset";
        //   expandSwatch.parentNode.style.height = "auto";
        //   expandSwatch.remove();
        // })

        // Redirect to the parent product page
        productItem.querySelector(".expand-swatches").addEventListener("click", function (event) {
          let productItemParent = event.currentTarget.closest('.product-item');
          let productUrl = productItemParent.dataset.productUrl;
          window.location.href = productUrl;
        })
      }
      if (productItem.querySelector(".cust-expand-swatches")) {
        var expandSwatch = productItem.querySelector(".cust-expand-swatches");
        productItem.querySelector(".cust-expand-swatches").addEventListener("click", function (event) {
         productItem.querySelector(".cust-expand-swatches").classList.add("active")
        })
      }
      if(isCust){
        productItem.querySelectorAll("[data-handle]").forEach( (dataProductHandle) => {
          dataProductHandle.querySelector("a").addEventListener("click",event => {
            event.preventDefault();
          })
          dataProductHandle.addEventListener('click', () => {
            productItem.querySelectorAll("[data-handle]").forEach(el => el.removeAttribute("selected"));
            dataProductHandle.setAttribute("selected","selected");
            const submit_btn = productItem.querySelector('[data-js-quick-buy-form]').querySelector("button[type='submit']")
            submit_btn.classList.add("working");
            submit_btn.setAttribute("disabled", true);
            const wrapper = dataProductHandle.closest(".product-color-swatches__wrapper");
            
            var imageUrl = dataProductHandle.querySelector(".hidevarimg").src;
            if (productImage) {
              productImage.src = imageUrl;
              productImage.style.display = "block";
            }
            productImageParent.classList.add("visible");
            const product_handle = dataProductHandle.dataset.handle;
            fetch("/products/"+product_handle+".json", {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }
            })
            .then(response => response.json())
            .then(response => {
              if(response.product && response.product.variants[0]){
                productItem.querySelector('[data-js-quick-buy-form]').querySelector("input[name='id']").value = response.product.variants[0].id
                productItem.querySelector('.product-item__title').href = productItem.querySelector('a').href
                productItem.querySelector('.product-item__title span').innerText = response.product.title
                productItem.querySelector('.product-price--original').innerHTML = _formatMoney(response.product.variants[0].price * 100, wrapper.dataset.moneyFormat)
                if(productItem.querySelector('.product-price--compare span')){
                  productItem.querySelector('.product-price--compare span').innerHTML = _formatMoney(response.product.variants[0].compare_at_price * 100,  wrapper.dataset.moneyFormat)
                }
              }
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {
                submit_btn.classList.remove("working");
                submit_btn.removeAttribute("disabled");
            });
          });
          // dataProductHandle.addEventListener('mouseout', function () {
          //   productImageParent.classList.remove("visible");
          // });
        });
      }else{
        productItem.querySelectorAll("[data-handle]").forEach(function (dataProductHandle) {
          dataProductHandle.addEventListener('mouseover', function () {
            var imageUrl = dataProductHandle.querySelector(".hidevarimg").src;
            if (productImage) {
              productImage.src = imageUrl;
              productImage.style.display = "block";
            }
            productImageParent.classList.add("visible");
          });
          dataProductHandle.addEventListener('mouseout', function () {
            productImageParent.classList.remove("visible");
          });
        });
      }
    });
  })
}

document.addEventListener('DOMContentLoaded', function() {
  reloadSwatches();

  document.querySelectorAll(".cust-featured-collection .product-color-swatches__wrapper").forEach(item => {
    const lis = item.querySelectorAll("li");
    lis.forEach(liItem => {
      
    })
  })
});
window.addEventListener('resize', function() {
  reloadSwatches();
});